import { ExchangeStatusType, type VenueHealth } from '@/types/generated/public_api'

/**
 * Gate live market-data subscriptions on the venue's public-feed health.
 * A missing snapshot remains fail-open so an unsupported or delayed health
 * stream can never take otherwise healthy ticker/chart data offline.
 */
export function shouldSubscribeToLiveMarketData(health: VenueHealth | undefined): boolean {
  if (!health) return true

  return health.data === ExchangeStatusType.EXCHANGE_STATUS_TYPE_OPEN
}
